var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { KeyIcon, PowerIcon, RectangleStackIcon, TrashIcon, } from "@heroicons/react/24/outline";
import { useContext } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { WPQTIconButton } from "../../../../components/common/Button/Button";
import { DELETE_USER, EDIT_USER } from "../../../../constants";
import { useUserActions } from "../../../../hooks/actions/useUserActions";
import { useLoadingStates } from "../../../../hooks/useLoadingStates";
import { UserContext } from "../../../../providers/UserContextProvider";
function UserControls({ data, changeStatus, changeSetUpStatus, changePasswordStatus, }) {
    const { changeUserStatus, deleteUser, resetUserPassword } = useUserActions();
    const { userDispatch } = useContext(UserContext);
    const { loading1: isResetPWLoading, setLoading1: setIsResetPWLoading, loading2: isActivateLoading, setLoading2: setIsActivateLoading, loading3: isDeleteLoading, setLoading3: setIsDeleteLoading, } = useLoadingStates();
    const isUserActive = data.is_active;
    const hasPassword = data.has_password;
    return (_jsxs("div", { className: "wpqt-mt-5 wpqt-flex wpqt-gap-2", children: [_jsx(WPQTIconButton, { icon: _jsx(RectangleStackIcon, { className: "wpqt-icon-blue wpqt-size-5" }), text: __("User tasks", "quicktasker"), onClick: () => {
                    window.location.hash = `#/users/${data.id}/tasks`;
                } }), !isUserActive && (_jsx(WPQTIconButton, { icon: _jsx(PowerIcon, { className: "wpqt-icon-green wpqt-size-5" }), text: __("Activate user", "quicktasker"), loading: isActivateLoading, onClick: () => __awaiter(this, void 0, void 0, function* () {
                    setIsActivateLoading(true);
                    yield changeUserStatus(data.id, true, (userData) => {
                        userDispatch({
                            type: EDIT_USER,
                            payload: Object.assign({}, userData),
                        });
                        changeStatus(true);
                    });
                    setIsActivateLoading(false);
                }) })), isUserActive && (_jsx(WPQTIconButton, { icon: _jsx(PowerIcon, { className: "wpqt-icon-red wpqt-size-5" }), text: __("Disable user", "quicktasker"), loading: isActivateLoading, onClick: () => __awaiter(this, void 0, void 0, function* () {
                    setIsActivateLoading(true);
                    yield changeUserStatus(data.id, false, (userData) => {
                        userDispatch({
                            type: EDIT_USER,
                            payload: Object.assign({}, userData),
                        });
                        changeStatus(false);
                    });
                    setIsActivateLoading(false);
                }) })), hasPassword && (_jsx(WPQTIconButton, { icon: _jsx(KeyIcon, { className: "wpqt-icon-red wpqt-size-5" }), loading: isResetPWLoading, text: __("Reset password", "quicktasker"), onClick: () => __awaiter(this, void 0, void 0, function* () {
                    setIsResetPWLoading(true);
                    yield resetUserPassword(data.id, () => {
                        changeSetUpStatus(false);
                        changePasswordStatus(false);
                    });
                    setIsResetPWLoading(false);
                }) })), _jsx(WPQTIconButton, { icon: _jsx(TrashIcon, { className: "wpqt-icon-red wpqt-size-5" }), loading: isDeleteLoading, text: __("Delete user", "quicktasker"), onClick: () => __awaiter(this, void 0, void 0, function* () {
                    setIsDeleteLoading(true);
                    yield deleteUser(data.id, (userId) => {
                        userDispatch({
                            type: DELETE_USER,
                            payload: userId,
                        });
                        window.location.hash = `#/users`;
                    });
                    setIsDeleteLoading(false);
                }) })] }));
}
export { UserControls };
